import {data} from './state';

/**
 * Establecer un valor para la variable data.
 */
export function resetData(state) {
    state.data = data();
}

/**
 * Establecer un valor para la variable preloader.
 */
export function setPreloader(state, preloader) {
    state.preloader = preloader;
}



// WEBPACK FOOTER //
// ./src/modules/sales-budgets/mutations.js